export default "__VITE_ASSET__934d734c__"